angular
  .module('capability-ng-scheduler')

  /**
   * @post add campus object to location object for easier access in sectiontime object
   */
  .constant('campusToLocationMappingFn', function campusToLocationMappingFn(data) {
    _.each(
      data.location,
      function (location) {
        this[location.id]._campus = _.find(data.campus, { id: location.campus });
      },
      this.location
    );
  })

  /**
   * @post get location and add to sectiontime object
   */
  .constant('locationToSectiontimeMappingFn', function locationToSectiontimeMappingFn(data) {
    _.each(
      data.sectiontime,
      function (sectiontime) {
        if (data.location && data.location[sectiontime.location]) {
          this[sectiontime.id].campus = data.location[sectiontime.location].campus;
          this[sectiontime.id]._location = data.location[sectiontime.location];
        }
      },
      this.sectiontime
    );
  })

  /**
   * @post sort sectiontimes by day of week ascending
   */
  .constant('sortSectionTimesByDayOfWeek', function sortSectionTimesByDayOfWeek(data) {
    data.sectiontime = _.sortBy(data.sectiontime, 'from_tm');
    data.sectiontime = _.sortBy(data.sectiontime, 'day_of_week');
  })

  /**
   * @post get section time and add to section object
   */
  .constant('sectiontimeToSectionMappingFn', function sectiontimeToSectionMappingFn(data) {
    _.each(
      data.sectiontime,
      function (sectiontime) {
        this[sectiontime.section]._section_times.push(sectiontime);
      },
      this.section
    );
  })

  /**
   * @post format section times, locations and campuses for display
   */
  //todo: This could be simpler - also produce what UI needs instead of sending data back.
  .constant('timeAndDateDisplayToSectiontimeMappingFn', function timeAndDateDisplayToSectiontimeMappingFn(data) {
    var daysOfWeekArray = ['', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

    _.each(
      data.section,
      function (section) {
        section._section_info_display = [];

        if (section.class_start_dt.format('YYYY') === section.class_end_dt.format('YYYY')) {
          section._starts_and_ends_in_same_year = true;
        }

        var sectionTimesByCampus = _.groupBy(section._section_times, 'campus'),
          _section_times_and_locations_at_campus = {};
        _.each(sectionTimesByCampus, function (sectionTimeByCampus) {
          var sectionTimesByLocation = _.groupBy(sectionTimeByCampus, 'location'),
            _section_times_with_locations = [];
          _.each(sectionTimesByLocation, function (sectionTimeByLocation) {
            var _section_times_at_location = {};
            _section_times_at_location.formattedTimes = [];

            var formattedTimes = [];
            _(sectionTimeByLocation)
              .each(function (sectiontime) {
                if (sectiontime.day_of_week === 8 || _.isEmpty(sectiontime.from_tm) || _.isEmpty(sectiontime.to_tm)) {
                  formattedTimes.push({
                    days: ['Meeting times TBD']
                  });
                  return false;
                }

                // match current section times against formatted times for current section
                var currentFormattedTimes;

                if (sectiontime.from_tm && sectiontime.to_tm) {
                  currentFormattedTimes = _.find(formattedTimes, {
                    from_tm: sectiontime.from_tm.format('h:mm a'),
                    to_tm: sectiontime.to_tm.format('h:mm a')
                  });
                }

                if (!_.isUndefined(currentFormattedTimes)) {
                  // if match found, add current sectiontime's day to days array
                  currentFormattedTimes.days.push(daysOfWeekArray[sectiontime.day_of_week]);
                } else if (!sectiontime.from_tm || !sectiontime.to_tm) {
                  // assume that null start or end time indicates time is TBD
                  // see src/schedule/views/schedule/factories/section_time_factory.js
                  formattedTimes.push({
                    days: [daysOfWeekArray[sectiontime.day_of_week]],
                    from_tm: 'TBD',
                    to_tm: 'TBD'
                  });
                } else {
                  // otherwise create a new object and push to formattedTimes array
                  formattedTimes.push({
                    days: [daysOfWeekArray[sectiontime.day_of_week]],
                    from_tm: sectiontime.from_tm.format('h:mm a'),
                    to_tm: sectiontime.to_tm.format('h:mm a')
                  });
                }
              })
              .value(); // end sectiontime loop

            _section_times_at_location.formattedTimes = formattedTimes;
            _section_times_at_location.location = sectionTimeByLocation[0]._location;
            _section_times_with_locations.push(_section_times_at_location);
          }); // end sectionTimeByLocation loop

          // sort locations by day of first meeting in week of that location
          _section_times_with_locations = _.sortBy(_section_times_with_locations, function (sectionTimesWithLocations) {
            return daysOfWeekArray.indexOf(sectionTimesWithLocations.formattedTimes[0].days[0]);
          });

          _section_times_and_locations_at_campus._section_times_with_locations = _section_times_with_locations;
          _section_times_and_locations_at_campus._campus = _section_times_with_locations[0].location._campus;

          section._section_info_display.push(_section_times_and_locations_at_campus);
          _section_times_and_locations_at_campus = {};
        }); // end sectionTimeByCampus loop
      },
      this
    ); // end section loop
  })

  /**
   * @post get campus and add to section object
   */
  .constant('campusToSectionMappingFn', function campusToSectionMappingFn(data) {
    _.each(
      data.section,
      function (section) {
        this.section[section.id]._section_campus = this.campus[section.campus];
      },
      this
    );
  })

  /**
   * @post get sectionstatus and add to section object
   */
  .constant('sectionstatusToSectionMappingFn', function sectionstatusToSectionMappingFn(data) {
    _.each(
      data.sectionstatus,
      function (sectionstatus) {
        this.section[sectionstatus.section]._section_status = sectionstatus;
      },
      this
    );
  })
  /**
   * @post get sectionstatus and add to section object
   */
  .constant('sectionTypeNameToSectionMappingFn', function sectionTypeNameToSectionMappingFn(data) {
    _.each(
      data.section,
      function (section) {
        var sectionType = _.find(data.section_type, (type) => type.id === section.section_type);
        if (section.section_type && sectionType) {
          section._section_type_name = _.isEmpty(sectionType.name) ? sectionType.cd : sectionType.name;
        }
      },
      this
    );
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/mapping_functions/mapping_functions.es.js